import { HARDCODED_DATA_KEY } from "src/stores/models/data-key";
import { AnswerItem, OutputTransformer } from "@types";

export const dataKeyToOutputTransformer: Record<string, OutputTransformer> = {
  [HARDCODED_DATA_KEY.COMPLAINT_LOG]: {
    outputTransformer: ({ answer, element }) => {
      const idHeader = "Complaint ID";
      const idDivider = "---";

      const fields = element.options.fields;
      const header = [idHeader, ...fields.map((field) => field.label)].join(
        " | "
      );
      const divider = [idDivider, ...fields.map(() => "---")].join(" | ");

      const rows = answer.map((item) => {
        return [
          item.type.concat(item.sequentialTypeNumber.toString()),
          ...fields.map((field) => item.fields[field.fieldKey]),
        ].join(" | ");
      });

      return `| ${header}\n| ${divider}\n| ${rows.join("\n")}`;
    },
  },
  [HARDCODED_DATA_KEY.LIST_OF_QUALIFIED_SUPPLIERS]: {
    outputTransformer: ({ answer, element }) => {
      const value = answer;
      const fields = element.options.fields;
      const rowLabels = element.options.fields.map((f) => f.label);

      // Generate markdown tables for each item in the value
      const markdownTables = value
        .filter((item: AnswerItem) => item.archived === false)
        .map((item: AnswerItem) => {
          let table = "| Category | Information |\n";
          table += "| -------- | ----------- |\n";
          rowLabels.forEach((label, index) => {
            const fieldKey = fields[index].fieldKey;
            table += `| ${label} | ${item?.fields?.[fieldKey] || ""} |\n`;
          });
          return table;
        })
        .join("\n");

      return markdownTables;
    },
  },
};
